import { PortalEnvSchema } from '@playerbase/types';

// Derive the Supabase Edge Functions base URL from the same env the
// supabase client reads. Local Supabase: http://127.0.0.1:54321. Cloud:
// https://<ref>.supabase.co. Both expose functions at /functions/v1/<name>.
// Lazy + memoised so the snippet builders can stay synchronous.
let cached: string | null = null;

export function getEdgeFunctionsBaseUrl(): string {
  if (cached !== null) return cached;
  const env = PortalEnvSchema.parse({
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
    VITE_SITE_URL: import.meta.env.VITE_SITE_URL,
  });
  cached = `${env.VITE_SUPABASE_URL.replace(/\/$/, '')}/functions/v1`;
  return cached;
}
